import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { Loader } from '../Components/Loader';

export const UserContext = createContext();

export const UserProvider = (props) => {
	const [userData, getUserData] = useState();
	const [userhasUnlimited, setUserhasUnlimited] = useState(false);
	const [userhasWineplan, setUserhasWineplan] = useState(false);
	const [defaultVelocityNumber, setDefaultVelocityNumber] = useState(null);
	const [defaultRAANumber, setDefaultRAANumber] = useState(null);

	useEffect(() => {
		fetchUserData();
		fetchThirdPartyList();
	}, []);

	const fetchUserData = () => {
		axios.get('/api/user/details').then((response) => {
			let fetchedResponse = response.data.response;
			getUserData(fetchedResponse);
			if (fetchedResponse.securityStatus >= 4) {
				getUserSubscriptions(fetchedResponse);
			}

			if (typeof AdobeDLFunctions !== 'undefined') {
				AdobeDLFunctions.dlUserUpdate(fetchedResponse);
			}
		});
	};

	const fetchThirdPartyList = () => {
		axios.get('/api/user/loyaltyprogram/thirdparty/list').then((res) => {
			const thirdPartyDetails = res?.data?.response?.thirdPartyDetails;
			if (thirdPartyDetails.length > 0) {
				const RAANUmber = thirdPartyDetails.find(
					({ programId }) => programId === 'RAA'
				);
				const velocityNumber = thirdPartyDetails.find(
					({ programId }) => programId !== 'RAA'
				);
				if (RAANUmber) {
					setDefaultRAANumber(RAANUmber.thirdPartyNumber);
				}
				if (velocityNumber) {
					setDefaultVelocityNumber(velocityNumber.thirdPartyNumber);
				}
			}
		});
	};

	const getUserSubscriptions = (fetchedResponse) => {
		let subscriptions = fetchedResponse?.trustedDetails?.subscriptions,
			activeULSubscriptions = null,
			activeWineplans = null;

		if (subscriptions && subscriptions.length > 0) {
			activeULSubscriptions = subscriptions.filter(function (item) {
				return (
					(item?.schemeTypes?.indexOf('FREESHIP') > -1 ||
						item?.schemeTypes?.indexOf('FreeShip') > -1 ||
						item?.types?.indexOf('FREESHIP') > -1) &&
					(item.status === 'ACTIVE' ||
						item.status === 'REQUESTED' ||
						item.status === 'SUSPENDED')
				);
			});

			if (activeULSubscriptions.length > 0) {
				setUserhasUnlimited(true);
			}

			activeWineplans = subscriptions.filter(function (item) {
				return (
					item?.type === 'WINEPLAN' &&
					(item.status === 'ACTIVE' ||
						item.status === 'REQUESTED' ||
						item.status === 'SUSPENDED')
				);
			});

			if (activeWineplans.length > 0) {
				setUserhasWineplan(true);
			}
		}
	};

	const logoutUser = () => {
		axios.post('/api/authentication/logout').then(() => {
			window.location.reload();
		});
	};

	return (
		<UserContext.Provider
			value={{
				userData,
				fetchUserData,
				userhasUnlimited,
				userhasWineplan,
				logoutUser,
				defaultVelocityNumber,
				defaultRAANumber,
				fetchThirdPartyList,
			}}
		>
			{userData ? props.children : <Loader />}
		</UserContext.Provider>
	);
};
